var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"icon-link",attrs:{"href":_vm.href,"target":'_blank'},on:{"click":_vm.handleClick}},[_c('Icon',{staticClass:"icon-link__icon",attrs:{"type":"button-arrow","height":13,"width":6.5}}),_vm._v(" "+_vm._s(_vm.label)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }